import { usePathname } from "next/navigation";
import { useCommonData } from "../../components/layout/CommonDataProvider";

export const useIsFrontPage = () => {
  const site = useCommonData();
  const pathName = usePathname();

  return pathName === `/${site.site?.defaultLanguage}`;
};
